import type { FieldConfig } from 'formik';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Checkbox } from '@lt/components';
import { useTranslation } from '@lt/localization';
import CustomerInput from '../CustomerInput';
import { EMPTY_PATRONYMIC } from './constants';

type CustomerPatronymicInputProps = {
  name: string;
  className?: string;
  header: string;
  placeholder: string;
  isMobile: boolean;
} & FieldConfig;

const CustomerPatronymicInput = (props: CustomerPatronymicInputProps) => {
  const { isMobile, name, ...other } = props;

  const { setFieldValue } = useFormikContext();

  const [hidePatronymic, setHidePatronymic] = useState(false);
  const toggleHidePatronymic = () => {
    setHidePatronymic((prevState) => !prevState);
    if (hidePatronymic) {
      setFieldValue(name, '');
    } else {
      setFieldValue(name, EMPTY_PATRONYMIC);
    }
  };

  const { t } = useTranslation();

  return (
    <PatronymicContainer isMobile={isMobile}>
      <CustomerInput
        name={name}
        disabled={hidePatronymic}
        isMobile={isMobile}
        {...other}
      />
      <Checkbox
        onClick={toggleHidePatronymic}
        checked={hidePatronymic}
        isMobile={isMobile}
      >
        {t('checkout.touristForm.patronymic.noPatronymic')}
      </Checkbox>
    </PatronymicContainer>
  );
};

const PatronymicContainer = styled.div<{ isMobile: boolean }>`
  ${(props) =>
    props.isMobile
      ? css`
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          max-width: none;
          flex-basis: 100%;
          margin-bottom: 7px;
          min-width: 40px;
        `
      : css`
          > * + * {
            margin-top: 6px;
          }
        `}
`;

export default CustomerPatronymicInput;
